import { GAME_INITIALIZED_PATH, GAME_LIFECYCLE_PATH, HOST_PATH, LAST_GAME_SUMMARY_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { DataListener } from "../../framework/layer/DataListener";
import { DataProvider } from "../../framework/layer/DataProvider";
const LOBBY_DATA_KEYS = [GAME_INITIALIZED_PATH, GAME_LIFECYCLE_PATH, HOST_PATH, LAST_GAME_SUMMARY_PATH];
export class LobbyDataListener extends DataListener {
    constructor(firebase, playerAndGameIdProvider) {
        super({
            firebase,
            listen: {
                paths: [GAME_INITIALIZED_PATH, GAME_LIFECYCLE_PATH, HOST_PATH, LAST_GAME_SUMMARY_PATH],
            },
            keyMapping: (input) => {
                switch (input) {
                    case GAME_LIFECYCLE_PATH:
                        return 'gameLifecycleStage';
                    default:
                        return input;
                }
            }
        });
        this.firebase = firebase;
        this.playerAndGameIdProvider = playerAndGameIdProvider;
    }
    activate() {
        const { gameId } = this.playerAndGameIdProvider.data;
        this.config.firebase = new GameIdFirebaseWrapper(this.firebase, gameId);
        super.activate();
    }
}
export class LobbyDataProvider extends DataProvider {
    constructor(dataListener) {
        super(dataListener, ['gameInitialized', 'gameLifecycleStage', 'host']);
    }
}
//# sourceMappingURL=LobbyDataLayers.js.map